module.exports = __webpack_public_path__ + "img/icon08.85ec3f4d.png";